import { axiosApiInstance } from "../axios";
import type { FinanceDateRangeValue } from "./dates";
import type { FinanceOverviewResponse } from "./overview-types";

export async function fetchFinanceOverview(
  range: FinanceDateRangeValue,
): Promise<FinanceOverviewResponse> {
  const response = await axiosApiInstance.get<FinanceOverviewResponse>(
    "finance/overview",
    {
      params: {
        from: range.from,
        to: range.to,
      },
    },
  );

  return response.data;
}
